<template>
  <el-form
    status-icon
    :model="driver"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    label-width="120px"
    v-loading="loading"
    class="carpo-form demo-ruleForm gap-y-6"
  >
    <el-form-item
      :label="$t('BLOOD_TYPE')"
      prop="blood_type"
      v-loading="bloodLoading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        clearable
        filterable
        v-model="driver.blood_type.id"
        :placeholder="$t('SELECT_PLACEHOLDER')"
      >
        <el-option
          v-for="item in bloodList"
          :key="item.id"
          :label="item.title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      :label="$t('NON_ADDICTION')"
      prop="has_certificate_of_non_addiction"
    >
      <el-select
        :disabled="ruleForm.disabled"
        filterable
        v-model="driver.has_certificate_of_non_addiction"
        :placeholder="$t('SELECT_PLACEHOLDER')"
      >
        <el-option
          v-for="item in addictedList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('HEALTH_LICESNCE_ID')" prop="health_license_id">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="driver.health_license_id = toEnglish(driver.health_license_id)"
        v-model="driver.health_license_id"
        autocomplete="off"
        class="left-inputs"
      ></el-input>
    </el-form-item>
    <el-form-item
      :label="$t('HEALTH_LICESNCE_EXPIRY_DATE')"
      prop="health_license_expiry_date"
    >
      <date-picker
        :disabled="ruleForm.disabled"
        color="#151515"
        class="el-input__inner"
        v-model="driver.health_license_expiry_date"
        view="year"
        format="jYYYY-jMM-jDD"
        clearable
        :locale="$i18n.locale"
      />
    </el-form-item>

    <FormConfirmation
      :loading="submitLoading"
      v-if="!ruleForm.disabled"
      @resetForm="resetForm('ruleForm')"
      @submitForm="submitForm('ruleForm')"
    />
  </el-form>
</template>

<script>
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import { driverBlood, getHealth, addHealth, editHealth } from '@/api/drivers'

export default {
  props: ['ruleForm', 'loading'],
  mixins: [gregorianToJalali, jalaliToGregorian],
  data() {
    return {
      bloodList: [],
      get_driver: null,
      bloodLoading: true,
      submitLoading: false,
      driver: this.ruleForm,
      addictedList: [
        {
          value: true,
          label: this.$i18n.t('PROVIDED'),
        },
        {
          value: false,
          label: this.$i18n.t('NOT_PROVIDED'),
        },
      ],
      rules: {
        has_certificate_of_non_addiction: [
          {
            required: false,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('NON_ADDICTION'),
            }),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const actionPayload = {
            blood_type: this.driver.blood_type ? this.driver.blood_type.id : '',
            has_certificate_of_non_addiction:
              this.driver.has_certificate_of_non_addiction,
            health_license_id: this.driver.health_license_id,
            health_license_expiry_date: this.jalaliToGregorian(
              this.driver.health_license_expiry_date,
              this.$i18n.locale
            ),
            driver: this.ruleForm.id,
            id: this.ruleForm.id,
          }
          this.submitLoading = true
          var dispatchFunc = this.get_driver == null ? addHealth : editHealth

          dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.get_driver = res
              this.$notify.success({
                title: this.$t('Health_INFO') + ' ' + this.$t('SUCCESSFULLY_'),
                duration: 5000,
                customClass: 'succ_msg',
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t('Health_INFO'),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  mounted() {
    driverBlood.api().then((res) => {
      if (res) {
        this.bloodList = res
        this.bloodLoading = false
      }
    })

    getHealth.api(this.ruleForm.id).then((res) => {
      this.loading = false
      if (res) {
        res = {
          ...res,
          health_license_expiry_date: this.gregorianToJalali(
            res.health_license_expiry_date
          ),
        }
        this.driver = res
        this.get_driver = res
        if (this.driver.blood_type === null) {
          this.driver.blood_type = {
            id: '',
          }
        }
      }
    })
  },
  components: {
    FormConfirmation,
  },
}
</script>
